export default "__VITE_ASSET__BVrfbf4U__"